@file:kotlin.js.JsExport
package com.narbase.letsgo.web.routing.domain.passenger.voiceassistant

import com.narbase.letsgo.router.EndPoint

object GetVoiceAssistantAvailabilityEndpoint :
    EndPoint<GetVoiceAssistantAvailabilityEndpoint.Request, GetVoiceAssistantAvailabilityEndpoint.Response>() {
    class Request
    class Response(
        val isEnabled: Boolean,
        val maxRecordingSeconds: Int,
        val remainingUsesToday: Int,
    )
}
